import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import api from "utils/api";
import { setLogin } from "state";
import "styles/auth.css";

const isEmployeeUser = (user) =>
  user?.isEmployee === true || user?.isEmployee === "true";

const EmployeeLogin = ({ onSuccess }) => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const { data } = await api.post("/auth/login", form);
      if (!isEmployeeUser(data.user)) {
        setError("Dieses Konto hat keinen Mitarbeiter-Zugang.");
        return;
      }
      if (data.user?.isAdmin) {
        setError("Bitte nutze den Admin-Bereich unter /admin-dashboard.");
        return;
      }
      dispatch(setLogin({ token: data.token, user: data.user }));
      onSuccess?.();
    } catch (err) {
      setError(err?.response?.data?.message || "Anmeldung fehlgeschlagen.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="team-login">
      <div className="auth-card team-login-card">
        <p className="auth-kicker">Mitarbeiter</p>
        <h1>
          Verfügbarkeit <em>verwalten</em>
        </h1>
        <p className="auth-lead">
          Melde dich an, um deine buchbaren Zeiten festzulegen.
        </p>

        {error && <div className="auth-alert is-error">{error}</div>}

        <form className="auth-form" onSubmit={handleSubmit} noValidate>
          <div>
            <label htmlFor="employee-login-email">E-Mail</label>
            <input
              id="employee-login-email"
              type="email"
              autoComplete="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </div>
          <div>
            <label htmlFor="employee-login-password">Passwort</label>
            <input
              id="employee-login-password"
              type="password"
              autoComplete="current-password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
          </div>
          <div className="auth-actions">
            <button type="submit" className="auth-submit" disabled={submitting}>
              {submitting ? "Anmelden…" : "Anmelden"}
            </button>
          </div>
        </form>

        <div className="auth-links">
          <Link to="/auth/passwort-vergessen">Passwort vergessen</Link>
          <Link to="/">Zur Website</Link>
        </div>
      </div>
    </section>
  );
};

export default EmployeeLogin;
